import { render, staticRenderFns } from "./VEmployeesTemplate.vue?vue&type=template&id=7902bea4&scoped=true&lang=pug"
import script from "./VEmployeesTemplate.vue?vue&type=script&lang=ts"
export * from "./VEmployeesTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeesTemplate.vue?vue&type=style&index=0&id=7902bea4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7902bea4",
  null
  
)

export default component.exports